import { useRemoteConfigBoolean } from "reactfire";
import { createLogger } from "../../utils/logger";

const logger = createLogger("useLoginEnabled");

export const useLoginEnabled = () => {
  const { data: loginEnabled, status } = useRemoteConfigBoolean("loginEnabled");

  if (status === "loading") {
    return false;
  }

  if (status === "error") {
    logger.error("Error fetching remote config for loginEnabled");
    return false;
  }

  return loginEnabled;
};
